import React, { useEffect, useState, useRef } from "react";
import { ContextProviderComponent } from "./Context.js";
import { graphql } from "gatsby";
import styled from "styled-components";
import GlobalStyle from "styles/globalStyles.js";
import Nav from "components/global/Nav.js";
import Footer from "components/global/Footer.js";
import InfoBar from "components/global/InfoBar.js";
import ContactForm from "components/global/ContactForm.js";
// import Footer from "components/global/Footer.js";
// import mediaQuery from "styles/mediaQuery";
// import Cookies from "src/components/global/Cookies.js";

const MainWrapper = styled.div`
  position: relative;
`;

const HomePage = ({ data, children, pageContext }) => {
  // const [isHydrated, setIsHydrated] = useState(false);

  // useEffect(() => {
  //   // Mark as hydrated after first render
  //   setIsHydrated(true);
  // }, []);

  // useEffect(() => {
  //   // Only run text replacement after hydration is complete
  //   if (!isHydrated) return;

  //   const lettersToReplace = [
  //     "a",
  //     "i",
  //     "o",
  //     "u",
  //     "w",
  //     "z",
  //     "A",
  //     "I",
  //     "O",
  //     "U",
  //     "W",
  //     "Z",
  //   ];
  //   const arrayLength = lettersToReplace.length;
  //   const elements = document.querySelectorAll("h1, h2, h3, p, span");

  //   elements.forEach((element) => {
  //     let textReplace = element.innerHTML;

  //     for (let i = 0; i < arrayLength; i++) {
  //       const textSplit = textReplace.split(` ${lettersToReplace[i]} `);
  //       textReplace = textSplit.join(` ${lettersToReplace[i]}&nbsp;`);
  //     }

  //     element.innerHTML = textReplace;
  //   });
  // }, [isHydrated]);

  return (
    <>
      <ContextProviderComponent>
        <MainWrapper>
          <InfoBar />
          <Nav />
          <GlobalStyle />
          {children}
        </MainWrapper>
        <Footer />
        <ContactForm />
      </ContextProviderComponent>
    </>
  );
};

export default HomePage;

export const Head = () => <></>;
